export default "__VITE_ASSET__091a72d2__"